import { CashPlusRouteName } from "@modules/cashplus/entities/cashplus.navigation.model";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from "@angular/router";
import { LaunchDarklyService, LD_FLAG } from "@core-services/launch-darkly/launch-darkly.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { CashplusNavigationService } from "@modules/cashplus/infrastructure/cashplus-navigation.service";

@Injectable({
	providedIn: "root"
})
export class CashplusFeatureFlagGuard implements CanActivate {
	public constructor(
		private navigationService: CashplusNavigationService,
		private launchDarklyService: LaunchDarklyService
	) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.launchDarklyService.isActive$(LD_FLAG.CASH_PLUS).pipe(
			tap((flag) => {
				if (flag) {
					return true;
				}

				this.navigationService.gotoByNavigationUrl(CashPlusRouteName.NotFound);
				return false;
			})
		);
	}
}
